// Library imports
import React, { useState } from "react";

// User Component imports
import OpsDialog from "../common/OpsDialog";
import { groupOf, verLabel, MESSAGE_MAX_LENGTH } from "../utils/promptVersions";
import PromptDiffView, { DiffNav, DiffToggles, useDiffOps, useDiffNav } from "./PromptDiffView";

// 未保存の入力（メモ）を失わないよう、背景クリックでは閉じない
const IgnoreBackdropClick = () => {};

/**
 * バージョン保存（isApply のときは保存して適用）のメモ入力と差分
 * 差分は、保存は編集元の版と、保存して適用は適用中の内容と比べる
 */
const PromptSaveModal = ({ modal, group, baseVer, basePair, current, initialTab, isBusy, onClose, onSave }) => {
    const [message, setMessage] = useState("");
    const [tab, setTab] = useState(initialTab);
    const [fullText, setFullText] = useState(false);
    const groupKey = modal.groupKey;
    const tooLong = message.length > MESSAGE_MAX_LENGTH;

    const left = modal.isApply ? { sys: group.system_prompt, user: group.user_prompt } : basePair;
    const leftTitle = modal.isApply
        ? `適用中（${verLabel(group.deployed_v, groupKey)}）`
        : (baseVer ? `編集元（${verLabel(baseVer, groupKey)}）` : "編集元なし");
    const sysDiff = useDiffOps(left.sys, current.sys);
    const userDiff = useDiffOps(left.user, current.user);
    const { ops, rows, hunks, stat } = tab === "sys" ? sysDiff : userDiff;
    const nav = useDiffNav(hunks, tab);

    const footer = (
        <>
            {modal.isApply &&
                <div className="ops-diff-apply-note">
                    <i className="bi bi-exclamation-triangle-fill" />
                    <span>
                        適用すると稼働中のAIの応答にすぐ反映されます。
                    </span>
                </div>
            }
            <button type="button" className="ops-footer-btn" onClick={onClose}>キャンセル</button>
            {!modal.isApply &&
                <button type="button" className="ops-footer-btn is-primary-outline" disabled={isBusy || tooLong}
                    title="保存して、稼働中のAIにすぐ反映します"
                    onClick={() => onSave(message.trim(), true)}>
                    保存して適用
                </button>
            }
            <button type="button" className="ops-footer-btn is-primary" disabled={isBusy || tooLong} onClick={() => onSave(message.trim(), modal.isApply)}>
                {modal.isApply ? "保存して適用" : "保存"}
            </button>
        </>
    );

    return (
        <OpsDialog
            show={true}
            className="ops-scope ops-diff-dialog"
            title={modal.isApply ? "編集中の内容を保存して適用" : "バージョンを保存"}
            subtitle={`${groupOf(groupKey)?.name ?? ""} ／ 編集元: ${baseVer ? verLabel(baseVer, groupKey) : "なし"}`}
            width={1760}
            headerRight={<>
                <DiffNav stat={stat} nav={nav} />
                <DiffToggles tab={tab} onChangeTab={setTab} fullText={fullText} onChangeFullText={setFullText}
                    counts={{ sys: sysDiff.count, user: userDiff.count }} />
            </>}
            footer={footer}
            showClose={true}
            onClose={onClose}
            onBackdropClick={IgnoreBackdropClick}
            bodyClassName="ops-diff-body"
        >
            <div className="ops-save-message">
                <label className="ops-save-message-label" htmlFor="ops-save-message">変更メモ（任意）</label>
                <textarea id="ops-save-message" className="ops-textarea ops-save-message-input" rows={3} value={message} maxLength={MESSAGE_MAX_LENGTH + 1} autoFocus
                    placeholder="" onChange={(e) => setMessage(e.target.value)} />
                {tooLong && <div className="ops-error-text">変更メモは{MESSAGE_MAX_LENGTH}文字以内で入力してください</div>}
            </div>
            <PromptDiffView ops={ops} rows={rows} nav={nav} tab={tab} leftTitle={leftTitle} rightTitle="現在の編集" fullText={fullText} onShowFull={() => setFullText(true)} />
        </OpsDialog>
    );
};

export default PromptSaveModal;
